var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouchdb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 120,
    y: 68,
    fill: "#E42528",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 56,
    y: 132,
    fill: "#C01C22"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 40,
    x: 18,
    y: 92,
    fill: "#F7F2F0",
    rx: 12
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 80,
    x: 20,
    y: 144,
    fill: "#B11A1E",
    rx: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 80,
    x: 172,
    y: 144,
    fill: "#B11A1E",
    rx: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 58,
    x: 84,
    y: 158,
    fill: "#8F1316",
    rx: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouchdb);
export default __webpack_public_path__ + "static/media/couchdb.9dca930fb863c34e1c0537698d26b268.svg";
export { ForwardRef as ReactComponent };